import { gql } from '@apollo/client';

// 复用 Dubbo 调试页的 Nacos 实例发现（同一 dubboQueryProviders）
export {
  DUBBO_QUERY_PROVIDERS,
  type DubboProviderInfo,
} from '../../dubbo-tools/graphql/dubboTools';

export const REFLECT_INVOKE = gql`
  mutation ReflectInvoke(
    $host: String!
    $port: Int!
    $className: String!
    $methodName: String!
    $args: [ReflectArgInput!]!
  ) {
    reflectInvoke(
      host: $host
      port: $port
      className: $className
      methodName: $methodName
      args: $args
    )
  }
`;
